import React, { useState } from 'react'

//Bibliotecas
import { set, useForm } from 'react-hook-form';
//Componentes
import { DangerButton, SecondaryButton } from '../../../components/common/Button';
import Modal from '../../../components/common/Modal';
import FlexContainer from '../../../components/common/FlexContainer';
import Form from '../../../components/common/Form';
import Input from '../../../components/common/Input';
import Error from '../../../components/common/Error';
//Servicios
import PerfilService from '../../../services/PerfilService';
import useAuth from '../../../hooks/useAuth';


function DeleteProfile({ deleteModal, setDeleteModal}) {
    //Estados
    const [deleteError, setDeleteError] = useState('');
    const {logout} = useAuth();
    const [loading, setLoading] = useState(false);
    //React Hook Form
    const { register, handleSubmit, formState: { errors }, reset } = useForm();


    //Manipuladores
    const onSubmit = (data) => {
        setLoading(true);
        PerfilService.eliminarPerfil({ data }).then((res) => {
            logout();
            setLoading(false);
        }).catch((error) => {
            setDeleteError(error.message);
            setLoading(false);
        })
    }
    
    function handleModalClose(){
        setDeleteModal(false);
        reset();
        setDeleteError('');
    }



    return (
        <>
            <Modal state={deleteModal} setState={setDeleteModal} title="Eliminar cuenta" padding='0px' headerPadding='16px' handleClose={handleModalClose}>
                <FlexContainer borderRadius='5px' textAlign='left'>
                    <FlexContainer padding='16px 32px'><p>Estás a punto de eliminar tu cuenta, se borrarán todos tus datos y el registro de progreso asociado<br /><b>Para confirmar que deseas eliminar tu cuenta, ingresa tu contraseña</b></p></FlexContainer>
                    <Form width='100%' padding='0' boxShadow='none' margin='0' onSubmit={handleSubmit(onSubmit)}  >
                        <Input
                            label='Contraseña'
                            name='password'
                            type="password"
                            placeholder="Ingresa tu contraseña"
                            register={register}
                            required={{ required: "Es necesario ingresar tu contraseña para eliminar la cuenta" }}
                            error={errors.password}
                        />
                        <FlexContainer borderRadius='5px' flexDirection='row' margin='16px 0 0 0' justifyContent='right' backgroundColor='var(--color-gris-claro)' padding='16px' >
                            <SecondaryButton width='30%' margin='0 16px' onClick={handleModalClose} disabled={loading}>Cancelar</SecondaryButton>
                            <DangerButton width='30%' margin='0' loading={loading}>Eliminar</DangerButton>
                        </FlexContainer>
                    </Form>
                    <FlexContainer backgroundColor='var(--color-gris-claro)' padding='8px 0 16px 0'>
                        {deleteError &&
                        <Error message={deleteError}></Error>
                    }</FlexContainer>
                </FlexContainer>
            </Modal>
        </>
    )
}

export default DeleteProfile